import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import { IconButton, Backdrop, CircularProgress, CssBaseline, TextField, Button, Container } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const ForgotPassword = ({ toggleColorMode }) => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [themeMode, setThemeMode] = useState('dark');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        try {
            const response = await axios.post('https://api.dmaverix.com/api/v2/auth/password/v-otp/forgot', { email });
            if (response.data.success) {
                setMessage('OTP sent to your email. Please check your inbox.');
                navigate('/reset-password', { state: { email } });
            } else {
                setMessage('Error sending OTP. Please try again.');
            }
        } catch (error) {
            setMessage('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
            const savedThemeMode = localStorage.getItem('themeMode') || 'dark';
            setThemeMode(savedThemeMode);
        }, []);
    const toggleTheme = () => {
        const newMode = themeMode === 'dark' ? 'light' : 'dark';
        setThemeMode(newMode);
        localStorage.setItem('themeMode', newMode);

    };

    const theme = createTheme({
        palette: {
            mode: themeMode,
            primary: {
                main: themeMode === 'light' ? '#6200ea' : '#bb86fc',
            },
            background: {
                default: themeMode === 'light' ? '#f5f5f5' : '#121212',
                paper: themeMode === 'light' ? '#ffffff' : '#333333',
            },
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <div style={{
                background: themeMode === 'light' ? 'linear-gradient(135deg, #975cd7, #5a8fea)' : 'linear-gradient(135deg, #121212, #333)',
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <Container maxWidth="xs" style={{ position: 'relative' }}>
                    <Backdrop open={loading} style={{ color: '#fff', zIndex: 1 }}>
                        <CircularProgress color="inherit" />
                    </Backdrop>

                    <div style={{
                        background: themeMode === 'light' ? 'rgba(255, 255, 255, 0.3)' : 'rgba(0, 0, 0, 0.5)',
                        padding: '30px',
                        borderRadius: '15px',
                        boxShadow: '0 8px 32px rgba(31, 38, 135, 0.37)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <h2 style={{ color: themeMode === 'light' ? '#333' : '#fff' }}>Forgot Password</h2>
                        {message && <p style={{ color: 'red', fontSize: '14px' }}>{message}</p>}

                        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <TextField
                                label="Email"
                                type="email"
                                variant="outlined"
                                fullWidth
                                placeholder="📧 Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                style={{
                                    margin: '10px 0',
                                    padding: '0px',
                                    width: '100%',
                                    border: '1px solid #ddd',
                                    borderRadius: '8px',
                                    outline: 'none',
                                    fontSize: '16px',
                                    transition: '0.3s',
                                    background: themeMode === 'light' ? 'rgba(255, 255, 255, 0.8)' : 'rgba(255, 255, 255, 0.2)',
                                    color: themeMode === 'light' ? '#333' : '#fff',
                                }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        padding: '12px 24px',
                                        background: themeMode === 'light' ? 'linear-gradient(90deg, #975cd7, #5a8fea)' : 'linear-gradient(90deg, #333, #121212)',
                                        color: '#fff',
                                        border: 'none',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        transition: '0.3s ease',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                    }}
                                >
                                    {loading ? 'Sending OTP...' : 'Submit'}
                                </Button>
                            </div>
                        </form>
                        <p style={{ marginTop: '15px', color: themeMode === 'light' ? '#D7127A' : '#E57373' }}>
                            Remembered your password ?{' '}
                            <Link
                                to="/login"
                                style={{
                                    color: themeMode === 'light' ? '#444444' : '#ffffff',
                                    textDecoration: 'none',
                                    fontWeight: 'bold',
                                }}
                            >
                                Login
                            </Link>
                        </p>
                    </div>
                </Container>

                <div style={{ position: 'absolute', top: '20px', left: '20px' }}>
                    <img src="/assets/logo.png" alt="Logo" style={{ width: '50px' }} />
                </div>
                <div style={{ position: 'absolute', top: '20px', right: '20px' }}>
                    <IconButton onClick={toggleTheme} style={{ color: '#fff' }}>
                        {themeMode === 'light' ? <DarkModeOutlinedIcon /> : <LightModeOutlinedIcon />}
                    </IconButton>
                </div>
            </div>
        </ThemeProvider>
    );
};

export default ForgotPassword;
